module.exports = __webpack_public_path__ + "static/logo-ff5833f5b33d1e32fe9588d35cd5a86d.png";